/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SupporterDethronedNotificationAction } from './SupporterDethronedNotificationAction';
import {
    SupporterDethronedNotificationActionFromJSON,
    SupporterDethronedNotificationActionFromJSONTyped,
    SupporterDethronedNotificationActionToJSON,
} from './SupporterDethronedNotificationAction';

/**
 * 
 * @export
 * @interface SupporterDethronedNotification
 */
export interface SupporterDethronedNotification {
    /**
     * 
     * @type {string}
     * @memberof SupporterDethronedNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof SupporterDethronedNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof SupporterDethronedNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof SupporterDethronedNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<SupporterDethronedNotificationAction>}
     * @memberof SupporterDethronedNotification
     */
    actions: Array<SupporterDethronedNotificationAction>;
}

/**
 * Check if a given object implements the SupporterDethronedNotification interface.
 */
export function instanceOfSupporterDethronedNotification(value: object): value is SupporterDethronedNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function SupporterDethronedNotificationFromJSON(json: any): SupporterDethronedNotification {
    return SupporterDethronedNotificationFromJSONTyped(json, false);
}

export function SupporterDethronedNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupporterDethronedNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(SupporterDethronedNotificationActionFromJSON)),
    };
}

export function SupporterDethronedNotificationToJSON(value?: SupporterDethronedNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(SupporterDethronedNotificationActionToJSON)),
    };
}

